module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("4")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "chaphead-image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("“I’ve Been to the Mountaintop”")])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("r. King arrived in Memphis early Wednesday afternoon and was met by Solomon Jones, a driver for a local funeral home that provided a white Cadillac as a makeshift limousine. A Memphis police security detail of four men, headed by chief of detectives Don Smith, was also there."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-1",
      "id": "ch04-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" Two other detectives later joined the group."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-2",
      "id": "ch04-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Jones took King and Abernathy to their usual lodging, the black-owned Lorraine Motel."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn04-04-1",
      "id": "fn04-1"
    }
  }, [_vm._v("*")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-3",
      "id": "ch04-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" From there they went to a strategy meeting at Lawson’s church, where they learned that Memphis city lawyers had successfully obtained a temporary injunction prohibiting King and the strikers from staging any protest for ten days. “Martin fell silent again,” recalled Abernathy. “Nothing was going right.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-4",
      "id": "ch04-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abernathy and King returned to the Lorraine to rest. They had landed in Memphis just ahead of a fierce storm, and by late afternoon the wind was "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("whipping around the balcony and the rain pelted the windows, punctuated by thunder and lightning. Through the miserable weather, at least six Memphis attorneys who had heard about the injunction traveled to the Lorraine to offer their assistance to King. King decided the lawyers, led by Lucius Burch, a prominent Memphian, should go to court the following morning to seek changes to the order. He warned Burch, however, that he was ready to march even if the injunction was in place.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("After dinner, Ralph Abernathy left alone to speak at Mason Temple. King was tired, and with the violent weather—“as bad a rain and wind as we’d seen in months,” recalled Abernathy—the men decided it was best for King to rest while Abernathy rallied the crowd.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn04-04-2",
      "id": "fn04-2"
    }
  }, [_vm._v("*")]), _vm._v(" There were about two thousand people at Mason Temple, a modest gathering compared to the crowd that had packed the grand, vaulted hall two weeks earlier for King. But they had ventured out in the terrible weather and were clearly disappointed when they did not see King. Abernathy called him and pleaded that he come over. King agreed, and when he finally arrived, Abernathy took the podium and gave a heartfelt thirty-minute introduction. Starting with King’s birth, he lionized almost every part of his life. It was an unusual departure for Abernathy, and later he could not explain why he had suddenly chosen that moment to deliver what "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("essentially became a eulogy. When he finished, one of the other ministers leaned over to him. “We thought you weren’t going to make a speech. Didn’t you know that they came to hear Martin?” Abernathy chuckled. “I don’t know, it just happened.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-5",
      "id": "ch04-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King started slowly. He paid tribute to Abernathy as “the best friend I have in the world.” Recounting an attempt on his life ten years earlier in a Harlem department store, when a deranged woman had stabbed him in the chest with a letter opener, King said the blade had struck so close to his heart that if he had sneezed he would have died. “And I want to say tonight, I want to say I am happy I didn’t sneeze.” Jim Lawson, who had walked to the back of the hall, listened to the speech, and when King talked about his brush with death, “I said to myself, ‘I’ve never heard him do that in public in quite that way’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-6",
      "id": "ch04-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His voice rising, King continued to list all the great episodes in the civil rights movement of the previous decade that he would have missed had he died. Then he spoke about the bomb threat on the plane earlier that morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And then I got into Memphis. And some began to say the threats, or talk about the threats that were out. What would happen to me from some of our sick white brothers? Well, I don’t know what will happen now. We’ve got some difficult days ahead. But it doesn’t really matter with me now.” He paused, and when he started again his voice rose. “Because I’ve been to the mountaintop.” The crowd was applauding frenetically. The storm—pelting rain and thunder—could be heard outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I don’t mind. Like anybody, I would like to live a long life. Longevity has its place. But I’m not concerned about that now. I just want to do God’s will. And He’s allowed me to go up to the mountain. And I’ve looked over. And I’ve "), _c('i', [_vm._v("seen”")]), _vm._v("—he lingered on the word—“the Promised Land. I may not get there with you. But I want you to know tonight, that we, as a people”—his words were rushed now, and forceful—“will get to the Promised Land. And I’m happy, tonight. I’m not worried about anything. I’m not fearing any man. Mine eyes have seen the glory of the coming of the Lord.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-7",
      "id": "ch04-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King was drenched in sweat, and as he moved back to his seat he almost collapsed into Ralph Abernathy’s arms. Some thought he was so swept by emotion that he was in tears. Young and Abernathy, who had heard variations of the speech many times, could not remember when King had seemed so involved in it, the passion of his words rousing the audience into a tumultuous cheer. “I heard him hit high notes before,” said Abernathy, “but never any higher.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-8",
      "id": "ch04-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" “It was remarkable,” agreed Lawson."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-9",
      "id": "ch04-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" “I never heard Martin talk about death publicly like that,” says Kyles. “That speech was a cleansing of his own fear of death. He purged himself of any foreboding he might have had about dying.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-10",
      "id": "ch04-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('p', {
    staticClass: "normal1"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The same day King made his “mountaintop” speech, Eric Galt finished his seven-hour drive from Atlanta and arrived in Memphis. He had stopped earlier in the day at a Rexall drugstore in Whitehaven, Tennessee, and purchased a Gillette shaving kit."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-11",
      "id": "ch04-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" The salesclerk later remembered him because he was wearing what appeared to be an expensive dark suit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-12",
      "id": "ch04-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Later, he stopped to get a haircut."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-13",
      "id": "ch04-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Around 7:15 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("., the Mustang with the Alabama license plate pulled into the New Rebel Motel at 3466 Lamar Avenue. Lamar was the continuation of Highway 78, just within the city limits. The storm was in full force, shaking the windows and rattling the doors of the fully exposed one-story motel. The desk clerk, Henrietta Hagemaster, greeted the single male customer looking for a room for the night. He filled out the registration slip as Eric S. Galt, listed his Mustang and its Alabama license number, and signed the card. She put him in Room 34.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ivan Webb replaced Hagemaster at 10:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". AS part of his overnight duties, he patrolled the motel’s grounds hourly as a security check."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-14",
      "id": "ch04-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" He noticed the Mustang parked in front of Room 34. Although the curtains were drawn shut, it was evident the room was brightly lit. During his 4:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". security walk, the room still had its lights on. Whoever is in there, thought Webb, is not getting much sleep tonight."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch04-04-15",
      "id": "ch04-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-left1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn04-1",
      "id": "fn04-04-1"
    }
  }, [_vm._v("*")]), _vm._v(" King’s checking into the Lorraine has been a source of controversy, as some have suggested that he seldom stayed there and somehow had been maneuvered to that motel since it might make him an easier target. In 1993, twenty-five years after the assassination, former King aide Hosea Williams testified in an HBO mock trial of James Earl Ray that he didn’t remember King ever staying at the Lorraine before the final trip to Memphis. “Hosea did not know about the Lorraine because he never had come to Memphis except one time before,” the Reverend Billy Kyles told the author. “Martin always stayed there. It was the one place he wanted to be at, and they treated him special. 306 was his room, the hotel’s best.” Ralph Abernathy told the House Select Committee on Assassinations, “We just felt a part of the Lorraine.… We always stayed there, and we always stayed in that room, 306. This was the King-Abernathy suite.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1-1"
  }, [_vm._v("Ray’s lawyer William Pepper also asserted that King’s room at the Lorraine was changed at the last second from 202 on the ground floor to 306 on the second floor, which afforded an assassin, placed across the road in the rooming house, a clear view. “Upon our arrival … someone else was in the room [306] and … the next day they were moved out and we were put in our usual room,” testified Abernathy. Walter Bailey, the Lorraine’s owner, said that his records showed that King had stayed at the hotel more than thirteen times, and 306 was always his room. The delay in moving him there on April 3 was, as Abernathy had recalled, because someone else initially occupied it.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn04-2",
      "id": "fn04-04-2"
    }
  }, [_vm._v("*")]), _vm._v(" By the time Abernathy had left, the police security detail was also gone. That has, of course, caused considerable speculation as to whether it was part of a coordinated plot to leave King vulnerable to an assassination attempt. However, the police detail was actually pulled away because King and his staff did not relish the police presence around them. Considering that the police had rioted and injured scores of black demonstrators only a week earlier, the image of the civil rights leader being surrounded by policemen was one he disliked and did not want in Memphis. Not only did King not wish to appear scared, but also he and his aides were not sure whether the police were there to protect him or to spy on him. When they returned from Lawson’s church to the Lorraine, King and his staff tried unsuccessfully to lose the police security detail. After that, security detail chief Smith called and received permission from headquarters to be removed from the scene. (HSCA Rpt., pp. 547–49.)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fabd6e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 87
// module chunks = 0